import React, { Component } from 'react'
import axios from 'axios'
import  { Icon } from 'antd'
import Title from './elements/TitlePages'
import ButtonActions from './elements/ButtonActions'

class Servers extends Component {
  constructor (props) {
    super(props)
    this.state = {
      servers: [],
      item: '',
      delete: false
    }
  }

  componentDidMount() {
    axios.get(window.baseURL + '/servers/').then(response => {
      this.setState({servers: response.data})
    }).catch(e => {
      console.log(e)
    })
  }

  deleteServ(id) {
    axios.get(window.baseURL +  '/servers/deleteServ/' + id).then(response => {
      if (response.data === 'ok') {
        axios.get(window.baseURL +  '/servers/').then(response => {
          this.setState({servers: response.data, delete: false, item: ''})
        }).catch(e => {
          console.log(e)
        })
      }
    }).catch(e => {
      console.log(e)
    })
  }

  renderDeleteAction (id) {
    return (
      <span>
        <button className='btn btn-success' onClick={() => this.setState({delete: false, item: ''})}>No</button> |
        <button className='btn btn-danger' onClick={() => this.deleteServ(id)}>Yes</button>
      </span>
    )
  }


  renderBody(server, key) {
    return(
      <tr key={key}>
        <th scope="row">{key}</th>
        <td>
          {server.servName} <br />
          <td>{server.ip}</td>
        </td>
        {/*  <td>{server.ip}</td> */}
        {/*  <td>{server.dominio}</td> */}
        <td>
          <ButtonActions link={`/main/edit-server/${server.id}`} action='' icon='edit' color='btn btn-outline-secondary' />
          {this.state.delete === false || this.state.item !== server.servName ? <button className='btn btn-outline-secondary' onClick={() => this.setState({delete: true, item:server.servName})}><Icon type="delete" /></button> : this.renderDeleteAction(server.id)}
        </td>
      </tr>
    )
  }

  render () {
    let key = 0
    return (
      <div>
        <Title title={'Servers'} />
        <ButtonActions link='/main/new-server' action='+ New Server' color='btn btn-info  ' />
        <br /><br />
        <div className='row' >
          <div className='col-md-9'>
            <table className='table table-striped'>
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Server / IP</th>
                  {/* <th scope="col">Ip</th> */}
                  {/* <th scope="col">dominio</th> */}
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {this.state.servers.map((product, key=+1) => this.renderBody(product, key))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

export default Servers